import axiosInstance from "./axios-instance";

const processDocument = (formType, file) => {
    const formData = new FormData();
    formData.append("formType", formType);
    formData.append("file", file);

    return axiosInstance.post("/app/document-scraping", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 120000,
    }).then(res => res);
};

const listActiveFormDefinitions = () =>
    axiosInstance.get("/app/document-scraping/active-form-definitions", { cache: false }).then(res => res);

const listFormDefinitions = () =>
    axiosInstance.get("/app/document-scraping/form-definitions", { cache: false }).then(res => res);

const updateFormDefinition = (formType, definition) =>
    axiosInstance.patch(`/app/document-scraping/form-definitions/${formType}`, definition).then(res => res);

export default {
    processDocument,
    listActiveFormDefinitions,
    listFormDefinitions,
    updateFormDefinition,
};
